import { api } from "@/lib/api";

export const NO_DEPOT_MSG = "Select Wholesaler — add a Cash & Carry supplier in Supplier Vault first";
export const savedDepot = () => localStorage.getItem("zc_selected_depot") || "";

// Store's own C&C / both suppliers; returns the saved one if still valid, else the first, else "".
export const resolveDepot = async () => {
  const { data } = await api.get("/suppliers/config");
  const cc = (data || []).filter((s) => ["cc", "both"].includes(s.service_type)).map((s) => s.name);
  const saved = savedDepot();
  const pick = cc.includes(saved) ? saved : cc[0] || "";
  if (pick) localStorage.setItem("zc_selected_depot", pick); else localStorage.removeItem("zc_selected_depot");
  return pick;
};
